<template>
  <!-- 在这不能使用背景颜色，需要从外部影响，涉及到背景图片的时候 -->
  <div class="top-header-area">
    <a-row>
      <a-col :span="2">
        <span class="back" @click="goBack">
          <a-icon :style="{ color: iconColor }" type="left" />
        </span>
      </a-col>
      <a-col :span="18" style="text-align: center;font-size: 16px;font-weight: bold;">
        <span :style="{ marginLeft: '-15px', color: titleColor }">{{ title }}</span>
      </a-col>
      <a-col :span="4" style="text-align: right;padding-right: 5px;">
        <router-link v-if="rightLinkLabel" :to="{ name: righLinkName }">
          {{ rightLinkLabel }}
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>
<script>

export default {
  name: 'InsideHeader',
  // 作用是：接收外部传递给组件的参数
  props: {
    title: {},
    color: {},
    backLinkName: {},
    righLinkName: {},
    rightLinkLabel: {}
  },
  data() {
    return {
      iconColor: '#999',
      titleColor: '#2c3e50',
      backgroundColor: '#fff'
    }
  },
  created() {
    if (this.color !== undefined) {
      if (this.color === 'white') {
        this.iconColor = '#fff'
        this.titleColor = '#fff'
      } else if (this.color === 'black') {
        this.iconColor = '#fff'
        this.titleColor = '#fff'
      } else if (this.color === 'grey') {
        this.iconColor = '#999'
        this.iconColor = '#333'
      }
    }
  },
  methods: {
    goBack() {
      if (this.backLinkName !== '' && this.backLinkName !== undefined) {
        this.$router.push({ name: this.backLinkName })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="stylus">
  .top-header-area {
    width: 100%;
    height: 44px;
    line-height: 44px;

    padding: 0 10px;

    .title {
      margin-left: 10px;
    }
  }
</style>
